import React, { useState } from 'react';
import { Spin, message } from 'antd';

import { ChangePasswordForm } from '../../components/user_management/change-password-form';
import { notifyError, notifySuccess } from '../../utils/notification';

const ChangePasswordView = function (props) {
	const [loading, setLoading] = useState(false);

	return (
		<div className="bg-overlay-dark">
			<div className="mx-auto form-container justify-content-center d-flex flex-column align-items-center py-3">
				<div className="m-4">
					<p
						style={{
							color: '#ffffff',
							fontSize: '2.625rem',
							fontWeight: 400,
							margin: '10px 0'
						}}
					>
						Change Your Password
					</p>
				</div>
				<div className="p-4 mt-0 my-md-5 ta-form-container">
					<Spin tip="please wait..." spinning={loading}>
						<ChangePasswordForm
							onSuccess={() => {
								notifySuccess('Password changed successfully!');
								setLoading(false);
							}}
							onError={msg => {
								notifyError(msg);
								setLoading(false);
							}}
							onSubmit={() => setLoading(true)}
						/>
					</Spin>
				</div>
			</div>
		</div>
	);
};

export default ChangePasswordView;
